import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import { editTypeSchedules } from '../../redux/actions/typeSchedules';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/typeScheduling';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    description: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const typeSchedules = useSelector(state => state.typeSchedules);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/type_schedules', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0]
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    dispatch(editTypeSchedules(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {typeSchedules.editSuccess && (
        <AlertMsg
          type="success"
          msg="Tipo de agendamento atualizado com sucesso"
        />
      )}
      {typeSchedules.errorContent &&
        !typeSchedules.errorContent.message.includes('400') &&
        typeSchedules.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do tipo de agendamento"
        />
      )}
      {typeSchedules.errorContent &&
        typeSchedules.errorContent.message.includes('400') &&
        typeSchedules.editError && (
        <AlertMsg
          type="danger"
          msg="Um tipo de agendamento com o nome informado já está cadastrado"
        />
      )}
      {!typeSchedules.editSuccess && !typeSchedules.editError && (
        <AlertMsg type="info" msg="Área atualização do tipo de agendamentos" />
      )}
      <FormHeader title="Atualizar Tipo de Agendamento" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/type_schedules" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
